<template>
<v-app>
    <header class="auth-header">
        <v-spacer />
        <div class="auth-header__inner">
            <img class="auth-header__logo" alt="Apio" src="@/assets/images/logo.svg" />
            <h1 class="auth-header__title">
                Connecting Commerce
            </h1>
            <h2 class="auth-header__sub-title">
                Take control of your integrations
            </h2>
        </div>
        <img class="auth-header__background" alt="" src="@/assets/images/Apio-Hero-Background.png" />
        <v-spacer />

        <v-card v-if="activated == 1" class="pa-6">
          <h2 class="ma-6">
              Activation Successful!
          </h2>
          <div>
          You can sign in on our <a href="/?#/pages/login">Login Page</a> now.
          </div>
        </v-card>

        <v-card v-if="activated == 2" class="pa-6">
          <h2 class="ma-6">
              Activation Error!
          </h2>
          <div>
          Please let us know what happened.
          </div>
        </v-card>

        <v-spacer />
    </header>
</v-app>
</template>

<script>
import request from '@/API/';

export default {
    name: 'Activate',
    data: () => ({
        activated: 0,
    }),
    mounted() {
      let self = this
      request.get('/user/activation?key='+this.$route.query.key).then(res=>{
        if (res.data.success) {
          self.activated = 1
        } else {
          self.activated = 2
        }
      }).catch(err => {
          console.log(err)
          self.activated = 2
      })
    }
};
</script>

<style lang="scss" src="./Register.scss" />
